import Vue from 'vue'

Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    let dollarUSLocale = Intl.NumberFormat('us-US');
    return dollarUSLocale.format(value) + '.00';
});